import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import ms from 'milliseconds';

const CouponValidityDate = ({
  startDate,
  expirationDate,
  startDateOnly,
  expirationDateOnly,
}) => {
  const isMultiDayCoupon =
    expirationDate &&
    startDate &&
    new Date(expirationDate).getTime() - new Date(startDate).getTime() >
      ms.days(1);
  const { formatMessage, formatDate } = useIntl();

  const getFormattedDate = (dateValue) =>
    formatDate(new Date(dateValue), {
      day: 'numeric',
      month: 'numeric',
      timeZone: 'UTC',
    });

  const expireDate = expirationDateOnly && getFormattedDate(expirationDateOnly);
  const startingDate = startDateOnly && getFormattedDate(startDateOnly);

  const getDateText = () => {
    if (isMultiDayCoupon) {
      return formatMessage(messages.multiDayCouponExpiration, {
        expireDate,
        startDate: startingDate,
      });
    } else if (expirationDate) {
      return formatMessage(messages.singleDayCouponExpiration, { expireDate });
    }
    return null;
  };

  return <Fragment>{getDateText()}</Fragment>;
};

export default CouponValidityDate;
